"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.getDiffTimeBySpeedStart = getDiffTimeBySpeedStart;

var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));

var _config = require("./config");

/**
 * @file 获取当前时间和起点差值
 * @author zhangyanting
 */

/**
 * 获取当前距离开始的时间差
 * @private
 */
function getDiffTimeBySpeedStart(time) {
  return (time || (0, _now.default)()) - _config.SPEED_START_TIME;
}